import {Inject, Injectable} from '@angular/core';
import {RegistrationRequest} from '../model/registration-request.model';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
import { HttpClient } from '@angular/common/http';
@Injectable()
export class RegistrationApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getProfileRegex() {
        return this.http.get(this.baseUri + '/register/profileregex');
    }

    validateToken(token: string) {
        return this.http.post(this.baseUri + '/register/validatetoken', { token });
    }

    validateTokenAndEmail(token: string, email: string) {
        return this.http.post(this.baseUri + '/register/validatetokenandemail', { token, email });
    }

    registerNewUser(registrationRequest: RegistrationRequest) {
        return this.http.post(this.baseUri + '/register/newuser', registrationRequest, { responseType: 'text' });
    }

    registerExistingUser(registrationRequest: RegistrationRequest) {
        return this.http.post(this.baseUri + '/register/existinguser', registrationRequest, { responseType: 'text' });
    }

    verifyRegistration(verificationToken: string) {
        return this.http.get(this.baseUri + '/register/verify/' + verificationToken, { responseType: 'text' });
    }
}